import type { JSX, ReactNode } from 'react';

type HeadingProps = {
  children?: ReactNode;
  level?: 1 | 2 | 3 | 4 | 5 | 6;
  align?: 'left' | 'center' | 'right';
  size?: 1 | 2 | 3 | 4 | 5 | 6;
  bold?: boolean;
  gutter?: boolean;
  gutterClass?: string;
  classes?: string;
};

const sizesMap = {
  1: 'text-h1',
  2: 'text-h2',
  3: 'text-h3',
  4: 'text-h4',
  5: 'text-h5',
  6: 'text-h6',
};


function Heading({
  children,
  level = 1,
  align = 'left',
  size,
  bold = true,
  gutter = true,
  gutterClass="mb-4",
  classes = '',
}: HeadingProps) {
  const Tag = `h${level}` as keyof JSX.IntrinsicElements;

  return (
    <Tag
      className={`text-${align} ${classes} ${size ? sizesMap[size] : ''} ${bold ? 'font-bold' : ''} ${gutter ? gutterClass : ''} 
      `}
    >
      {children}
    </Tag>
  );
}

export default Heading;
